<template>
  <section class="vr360-app">
    <header-list></header-list>
    <main class="vr360-app-main vr360-wrap__inner" ref="scrollContainer">
      <router-view :key="$route.path"/>
    </main>
    <footer-list />
  </section>
</template>

<script>
import { mapActions } from "vuex";

import headerList from "@/components/app/partials/HeaderList";
import footerList from "@/components/app/partials/FooterList";

const arrWhereFooter = ["ListPublicStreams", "ListMyStreams"];

export default {
  name: "App",
  components: {
    headerList,
    footerList
  },
  mounted() {
    this.setScrollBlock(this.$refs.scrollContainer);
  },
  beforeDestroy() {
    this.setScrollBlock(null);
  },
  methods: {
    ...mapActions({
      setScrollBlock: "setScrollBlock",
      clearStreams: "stream/clearStreams"
    })
  },
  watch: {
    $route(to, from) {
      if (
        arrWhereFooter.indexOf(to.name) > -1 &&
        arrWhereFooter.indexOf(from.name) > -1
      ) {
        this.clearStreams();
      }
    }
  }
};
</script>

<style lang="scss">
</style>
